import TableCustomized from "../../../common/components/TableCustomized";
import PaperCustomized from "../../../common/components/PaperCustomized";

function ListMarchandises(props) {
  const columns = [
    {
      field: "designation",
      headerName: "Désignation commerciale",
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "nomenclature",
      headerName: "Nomenclature douanière",
      flex: 1.25,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "paysOrigine",
      headerName: "Pays d'origine",
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "poidsNet",
      headerName: "Poids Net",
      flex: 0.5,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "unite",
      headerName: "Unité",
      flex: 0.5,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "qte",
      headerName: "Quantité",
      flex: 0.5,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "uniteComp",
      headerName: "Unités complémentaires",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
  ];
  const rows = [];
  props?.detail?.arrTiMercancia?.map((row, index) => {
    rows.push({
      id: row.id,
      designation: row.designationCommerciale,
      unite:
        "(" + row.uniteDouaniere?.code + ") " + row.uniteDouaniere?.description,
      uniteComp: row.uniteComplementaire?.description,
      paysOrigine: row.paysOrigine?.description,
      nomenclature:
        row.nomenclaturaAduanera?.code +
        "-" +
        row.nomenclaturaAduanera?.description,
      qte: row.quantite,
      poidsNet: row.poidsNet,
    });
  });
  return (
    <PaperCustomized
      title={props?.modified ? "Marchandises approuvées" : "Marchandises"}
      forActions={false}
    >
      <TableCustomized
        columns={columns}
        rows={rows}
        totalElements={rows.length}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationMode="client"
        isSlots={false}
        isFooter={true}
        noDataHeight="120px"
        cursor="auto"
      />
    </PaperCustomized>
  );
}

export default ListMarchandises;
